import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/app/(publicScreens)/ingredients/[slug]/BackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/app/(publicScreens)/ingredients/[slug]/IngredientSignUpCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GrowingFarmers"] */ "/codebuild/output/src3993831471/src/web/components/growingFarmer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IngredientRecipes"] */ "/codebuild/output/src3993831471/src/web/components/IngredientRecipes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/components/IngredientShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IngredientSteps"] */ "/codebuild/output/src3993831471/src/web/components/ingredientsSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/components/introSectionIngredient.tsx");
